import React from "react";
import Modal from "react-bootstrap/Modal";
import { Globe2, MessageSquareText, Search } from "lucide-react";
import { gitchaExplainerUrl, trackGitchaExplainerClick } from "@/helpers/gitchaExplainer";
import GitchaLogo from "@/images/gitcha-logo.svg";
import "./GitchaExplainerSheet.scss";

const rowsFor = (networkName) => [
  {
    icon: Search,
    title: "Home shoppers look up local demand",
    body: "Gitcha.com shows homeowners and buyers what agents' clients want in their area, so they can see the real-time demand for a home like theirs.",
  },
  {
    icon: Globe2,
    title: "Your syndicated Buyer Want-Listings show there",
    body: `Any Buyer Want-Listing you syndicate from ${networkName} appears on Gitcha.com and on your Gitcha bio, credited to you.`,
  },
  {
    icon: MessageSquareText,
    title: "Shoppers reach you from your bio",
    body: "They can call, text or message you, and every contact shows in your notifications. With Gitcha Pro they can also send their name, timing and what they need in a short form.",
  },
];

const GitchaExplainerSheet = ({ show, onHide, networkName = "your MLS", surface = "explainer_sheet" }) => (
  <Modal show={show} onHide={onHide} centered className="gitcha-explainer modal-width-548">
    <Modal.Body>
      <div className="gitcha-explainer__head">
        <img src={GitchaLogo} alt="Gitcha" className="gitcha-explainer__logo" />
        <button type="button" className="gitcha-explainer__close" aria-label="Close" onClick={onHide}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </div>
      <h2 className="gitcha-explainer__title">What Gitcha.com does for&nbsp;you</h2>
      <ul className="gitcha-explainer__rows">
        {rowsFor(networkName).map(({ icon: Icon, title, body }) => (
          <li key={title}>
            <span className="gitcha-explainer__icon" aria-hidden="true">
              <Icon size={18} />
            </span>
            <span className="gitcha-explainer__copy">
              <b>{title}</b>
              {body}
            </span>
          </li>
        ))}
      </ul>
      <a
        className="gitcha-explainer__more"
        href={gitchaExplainerUrl(surface)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackGitchaExplainerClick(surface)}
      >
        How syndication works&nbsp;&rarr;
      </a>
    </Modal.Body>
  </Modal>
);

export default GitchaExplainerSheet;
